import { useSelector } from 'react-redux';
import { IRootState } from '@state/reducers/Reducers';
import { PageName } from '@utils/pageConfig/Types';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { LoadedCountriesState } from '@state/feature/availability-country/AvailabilityCountrySlice';

const MULTI_COUNTRY_PAGES: PageName[] = [PageName.PERFORMANCE_ANALYSIS, PageName.EXPLORE];

export const useGetLoadedCountries = (): { loadedCountries: LoadedCountriesState } | {} => {
  const { unavailableCountriesByPeriodAndPg, subscribedCountries } = useSelector(
    (state: IRootState) => state.availabilityCountry,
  );
  const { pageName } = usePageConfig();

  return MULTI_COUNTRY_PAGES.includes(pageName)
    ? {
        loadedCountries: {
          subscribedCountries,
          unavailableCountriesByPeriodAndPg,
        },
      }
    : {};
};
